import { frameAt } from './math';
import type { Actor, Point, Theme } from './types';

/** The renderer and attachments must sample exactly the same animation frame. */
export function sampleSprite(actor: Actor, theme: Theme) {
  const clip = theme.clips[actor.pose] ?? theme.clips.idle;
  let frame = frameAt(clip.frames, clip.fps, actor.poseTime, clip.loop);
  if (clip.lookFrames && actor.look) {
    frame =
      actor.look.y < -0.25
        ? clip.lookFrames.up
        : actor.look.y > 0.25
          ? clip.lookFrames.down
          : clip.lookFrames.neutral;
  }
  const asset = clip.asset ?? 'character';
  const atlas = asset === 'character' ? theme.character : theme.atlases?.[asset];
  if (!atlas) throw new Error(`Animate: missing sprite atlas "${asset}" in ${theme.id}.`);
  return {
    asset,
    frame,
    rect: atlas.frames[frame]!,
    pivot: atlas.pivots?.[frame] ?? { x: atlas.frames[frame]![2] / 2, y: atlas.frames[frame]![3] },
    scale: (actor.size / atlas.unitHeight) * (clip.scale ?? 1),
  };
}

export function projectileAnchor(actor: Actor, theme: Theme): Point {
  const { frame, rect, scale } = sampleSprite(actor, theme);
  const anchor = theme.character.projectileAnchors?.[frame];
  if (!anchor) return { x: actor.x, y: actor.y - actor.size * 0.7 };
  return {
    x: actor.x + (anchor.x - rect[0] - rect[2] / 2) * scale * actor.facing,
    y: actor.y + (anchor.y - rect[1] - rect[3]) * scale,
  };
}
